<template>
  <div class="has-friend-wrapper" key="search-bar">
    <div class="input-wrapper">
      <div class="search-group">
        <Input icon="icon-search-bold" v-model="friendSearch" placeholder="搜索好友" clearable/>
        <div class="add-friend-btn" @click="SET_ADD_FRIEND_MODAL(true)">
          <i class="iconfont icon-add-bold"></i> 
        </div>
      </div>
    </div>
    <SkeletonFriendList v-if="!isCompleted" key="skeleton-content" />
    <div
      v-else
      key="content"
      @scroll.passive="handleFriendListScroll"
      ref="friendScrollList"
      class="hover-scrollbar wh-full pl-[8px] overflow-x-hidden overflow-y-scroll"
    >
      <!-- 搜索好友状态 -->
      <div class="scroll-container" style="padding: 0 8px" v-if="friendSearch">
        <FriendUserItem
          v-for="(friend) in searchFriends" 
          :key="friend.user_id + '-search'"
          @dblclick.native="localPrivateChatHandler(friend)"
          :friend="friend"
          :active="friend.user_id == active_user_card"
          @inviteFriend="inviteFriend"
          @joinChannel="joinChannel"
        ></FriendUserItem>
      </div>
      <!-- 有好友正常展示状态 -->
      <div v-else class="scroll-container friends-members">
        <TopList :init-data="topFriendList"/>
        <!-- 以房间、频道分类好友树 -->
        <div class="rooms" v-if="friends_data.rooms && friends_data.rooms.length > 0">
          <div class="room" v-for="room in friends_data.rooms || []" :key="room.room_id">
            <GroupTitle
              @click="hideRoom(room.room_id)"
              @roomIcon="joinChannel({
                room_id: room.room_id,
                user: room.channels[0]?.friends[0]
              })"
              :room="room"
              :text="`${room.room_name} — ${roomMemberCnt(room)}`"
              :isHide="room_hide_bl[room.room_id]"
            ></GroupTitle>
            <div
              v-if="!room_hide_bl[room.room_id]"
              class="channel-container"
            >
              <div 
                class="channel-wrapper relative"
                v-for="channel in room.channels || []"
                :key="channel.channel_id"
              >
                <FriendUserItem
                  v-for="friend in channel.friends || []"
                  :key="channel.channel_id + friend.user_id"
                  @dblclick.native="localPrivateChatHandler(friend)"
                  :friend="friend"
                  :active="friend.user_id == active_user_card"
                  @inviteFriend="inviteFriend"
                  @joinChannel="joinChannel({
                    room_id: room.room_id,
                    channel_id: channel.channel_id,
                    user: friend
                  })"
                  :showFollowIcon="true"
                ></FriendUserItem>
                <div 
                  v-tooltip="{ text: `点击进入${channel.channel_name}频道` }"
                  class="talk-other-num h-[32px] py-[2px] pl-[26px] pointer" 
                  @click="joinChannel({
                    room_id: room.room_id, 
                    channel_id: channel.channel_id, 
                    user: channel.friends[0],
                  })">
                  <div class="flex p-[5px] pb-[7px] pl-[8px] h-[28px] rounded-[5px] hover:bg-op-1">
                    <span class="blod" v-if="(channel.count - channel.friends.length) > 0">+{{channel.count - channel.friends.length}}</span>
                    <span 
                      class="weak ellipsis" 
                      :class="{
                        'short-width': (channel.count - channel.friends.length) > 0 
                      }" 
                      v-html="getChannelMutiDes(channel)"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="split"></div>
          </div>
        </div>
        <!-- 独自在房间 & 普通在线好友 -->
        <div class="online-friend" v-if="(friends_data.single_user_rooms.length + friends_data.online_friends.length) > 0">
          <GroupTitle
            @click="hideFriendBlock('online')"
            :text='`在线好友 — ${onlineFriendsCnt}`'
            :isHide="isHideFriendBlock['online']"
          ></GroupTitle>
          <div class="friend-list-wrapper" v-if="!isHideFriendBlock['online']">
            <div
              class="single-room-user h-[46px] my-[4px] mb-[2px] flex items-center pointer"
              :class="[{active: room.channels[0].friends[0].user_id == active_user_card}, `single-room-user-${room.room_id}`]"
              v-for="(room, i) in friends_data.single_user_rooms"
              :key="room.room_id + room.channels[0].friends[0].user_id + 'online'"
              ref="single-room-user"
            >
              <ChatRoomAvatar
                v-tooltip="{ text: room.room_name }"
                :width="18"
                :img="room.room_avatar"
                :room_name="room.room_name"
                :webp_quality="50"
                :radius="3"
                :keep_active="true"
                :chat_img_props="{
                  gif_active_type: 'hover',
                  hover_dom_handler: () => {
                    return isCompleted ? $refs['single-room-user'] && $refs['single-room-user'][i] : null
                  }
                }"
                @click.native.stop="joinChannel({
                  room_id: room.room_id,
                  channel_id: room.channels[0].channel_id,
                  user: room.channels[0].friends[0],
                })"
              />
              <FriendUserItem
                @dblclick.native="localPrivateChatHandler(room.channels[0].friends[0])"
                :friend="room.channels[0].friends[0]"
                @inviteFriend="inviteFriend"
                @joinChannel="joinChannel({
                  room_id: room.room_id,
                  channel_id: room.channels[0].channel_id,
                  user: room.channels[0].friends[0],
                })"
                :disableHover="true"
                :inviteTime="inviteTime"
                :showFollowIcon="true"
              />
            </div>
            <div class="split" v-if="friends_data.single_user_rooms.length > 0 && friends_data.online_friends.length > 0"></div>
            <FriendUserItem
              v-for="(friend) in friends_data.online_friends"
              :key="friend.user_id + 'online'"
              @dblclick.native="localPrivateChatHandler(friend)"
              :friend="friend"
              @inviteFriend="inviteFriend"
              :inviteTime="inviteTime"
              :active="friend.user_id == active_user_card"
              :showFollowIcon="true"
            />
          </div>
          <div class="split"></div>
        </div>
        <!-- Steam好友 -->
        <div class="steam-friend" v-if="isShowSteamFriend">
          <GroupTitle
            :text="`Steam好友`"
            @click="hideFriendBlock('steam')"
            :isHide="isHideFriendBlock['steam']"
          >
            <template #left-icon>
              <i 
                class="iconfont icon-platform-steam" 
                style="font-weight: normal; font-size: 18px; margin-right: 6px;">
              </i>
            </template>
          </GroupTitle> 
          <SteamUserList 
            v-if="!isHideFriendBlock['steam']" 
            :steamFriends="friends_data.steam_friends"
          >
          </SteamUserList>
          <div class="split"></div>
        </div>
        <!-- 离线好友 -->
        <div class="offline-friend" v-if="friends_data.offline_friends.length > 0">
          <GroupTitle
            @click="hideFriendBlock('offline')"
            :text="`离线好友 — ${offlineFriendsCnt}`"
            :isHide="isHideFriendBlock['offline']"
          ></GroupTitle>       
          <div class="friend-list-wrapper" v-if="!isHideFriendBlock['offline']">
            <FriendUserItem
              v-for="friend in friends_data.offline_friends"
              :key="friend.user_id + 'offline'"
              @dblclick.native="localPrivateChatHandler(friend)"
              :friend="friend"
              @inviteFriend="inviteFriend"
              :active="friend.user_id == active_user_card"
              :inviteTime="inviteTime"
            ></FriendUserItem>
          </div>
          <div class="split" v-if="friends_data.offline_friends.length > 0"></div>
        </div>
        <!-- 推荐好友 -->
        <div class="recommends" v-if="recommend_friends.length > 0">
          <GroupTitle
            @click="hideFriendBlock('recommend')"
            text="可能认识的人"
            :isHide="isHideFriendBlock['recommend']"
          ></GroupTitle>
          <RecommendUserList
            v-if="!isHideFriendBlock['recommend']"
            :active_user_card="active_user_card"
            :sendAddFriend="sendAddFriend"
            :transitionClass="'friend-list-wrapper'"
          />
          <ChatMoreLoading v-if="!isHideFriendBlock['recommend'] && recommendsScrollToBottomLoading"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import GroupTitle from '_com/func/HideGroupTitle'
import FriendUserItem from '_com/busy/FriendUserItem.vue'
import SkeletonFriendList from './SkeletonFriendList.vue';
const RecommendUserList = () => import('./RecommendUserList.vue');
const SteamUserList = () => import('./SteamFriendsList.vue');
const TopList = () => import('_com/busy/TopList.vue')

import EventBus from '_lib/EventBus';

export default {
  components: {
    GroupTitle,
    FriendUserItem,
    TopList,
    SkeletonFriendList,
    RecommendUserList,
    SteamUserList
  },
  inject: ['localPrivateChatHandler', 'inviteFriend', 'sendAddFriend'],
  props: {
    topFriendList: {
      type: Array,
      default: () => [],
    },
    friends_data: {
      type: Object,
      default: () => ({
        rooms: [],
        single_user_rooms: [],
        online_friends: [],
        offline_friends: [],
        steam_friends: [],
      }),
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      friendSearch: '',
      recommendsScrollToBottomLoading: false,
      room_hide_bl: {},
      inviteInterval: null, // 邀请计时器
      inviteTime: 0, // 计时时间
    }
  },
  computed: {
    ...mapGetters([
      'setting_data',
      'active_user_card',
      'recommend_friends',
      'friends_map',
      "user_account_settings"
    ]),
    searchFriends () {
      if (this.friendSearch) {
        return Object.values(this.friends_map).filter((v) => {
          return ('' + v.user_id).includes(this.friendSearch) || v.nickname.toLowerCase().includes(this.friendSearch.toLowerCase()) || v.remarks.toLowerCase().includes(this.friendSearch.toLowerCase());
        });
      } else {
        return [];
      }
    },
    isHideFriendBlock () {
      return this.setting_data.hide_friend_types
    },
    //在线好友人数展示
    onlineFriendsCnt() {
      return this.friends_data.single_user_rooms.length + this.friends_data.online_friends.length
    },
    //离线好友人数展示
    offlineFriendsCnt() {
      return this.friends_data.offline_friends.length
    },
    isShowSteamFriend() {
      // INFO: 显示 Steam 好友的条件
      // 01 客户端 - 设置中开启了"获取Steam状态"
      // 02 在房间中（后续产品设计取消该条件）
      return this.friends_data.steam_friends?.length > 0 && process.env.IS_CLIENT 
      && this.user_account_settings.allow_steam_nethook === 1
    }
  },
  mounted() {
    this.inviteInterval = setInterval(() => {
      this.inviteTime++
    }, 1000)
  },
  beforeDestroy() { 
    clearInterval(this.inviteInterval)
  },
  methods: {
    async handleFriendListScroll(event) {
      if (this.isHideFriendBlock['recommend']) return
      let friendScrollList = event.target
      let {scrollTop, clientHeight, scrollHeight} = friendScrollList
      let scrollToBottom = Math.abs((scrollTop + clientHeight) - scrollHeight) < 1
      if (scrollToBottom && !this.recommendsScrollToBottomLoading) {
        this.recommendsScrollToBottomLoading = true
        this.$emit('getRecommendFriend', () =>{
          this.recommendsScrollToBottomLoading = false
        })
      }
    },
    joinChannel (data) {
      let { room_id, channel_id, user } = data
      EventBus.$jump({
        channel_id,
        room_id,
        nickname: user.nickname,
        user_id: user.user_id,
      }, 'friends-list-follow')
      if(this.$route.name === 'home') {
        this.SET_DISCOVER_ENTER_WAY('friends-list-follow')
      }
    },
    getChannelMutiDes(channel) {
      if ((channel.count - channel.friends.length) <= 0) {
        return `<span class="friend_muti_des_channel_name">${channel.channel_name}</span>` + ' 频道语音中'
      } else {
        let str = '与', l = []
        if (channel.with_me) {
          l.push('我')
        }
        if (channel.count - channel.friends.length - (channel.with_me ? 1 : 0) > 0) {
          l.push(`其他${channel.count - channel.friends.length - (channel.with_me ? 1 : 0)}人`)
        }
        str += l.join('、')
        str += ' ' + `<span class="friend_muti_des_channel_name">${channel.channel_name}</span>` + ' 频道语音中'
        return str
      }
    },
    hideRoom(id) {
      this.$set(this.room_hide_bl, id, this.room_hide_bl[id] ? false : true)
    },
    hideFriendBlock(type) {
      this.$emit('hideFriendBlock', type)
    },
    roomMemberCnt(room) {
      let cnt = 0
      room.channels.forEach(channel => {
        if(channel.friends) {
          cnt += channel.friends.length || 0
        }
      })
      return cnt
    },
    ...mapMutations([
      'SET_ADD_FRIEND_MODAL',
      'SET_DISCOVER_ENTER_WAY',
    ]),
  }
}
</script>

<style lang="scss">
.friends-members {
  .rooms {
    .room {
      .channel-container{
        transition: all .2s linear;
      }
      .channel-wrapper {
        &::after {
          content: '';
          border: 2px solid $d-op-1;
          border-right: 0px;
          border-radius: 5px 0 0 5px;
          position: absolute;
          left: 16px;
          width: 8px;
          top: 23px;
          bottom: 14px;
        }
        .cpt-friend-item {
          margin-left: 26px;
        }
        .talk-other-num {
          .blod {
            margin-right: 10px;
            width: 32px;
            font-family: 'Roboto';
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            letter-spacing: 0.01em;
            color: $d-bd-tx;
            text-align: center;
            flex-shrink: 0;
          }
          .weak {
            font-weight: 400;
            font-size: 22px;
            line-height: 32px;
            height: 32px;
            min-width: 418px;
            letter-spacing: 0.01em;
            color: $d-ol-tx;
            opacity: 0.7;
            transform: scale(.5);
            transform-origin: left top;
            display: flex;
            &.short-width {
              min-width: 334px;
            }
          }
        }
      }
    }
  }
  .friend-list-wrapper{
    .single-room-user {
      &:hover, &.active {
        background: $d-op-1;
        border-radius: 5px;
      }
      .cpt-chat-room-avatar{
        margin-left: 8px;
        margin-right: 0;
      }
      .cpt-friend-item {
        flex: 1;
        margin: 0px;
        &:hover, &.active {
          background: transparent;
        }
      }
    }
  }
}

</style>